exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.addToCartDisabled {\n  background: #48bb78 !important;\n  cursor: pointer !important;\n  display: block;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
